// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"cfa8aff4","513":"e28027df","703":"cd0dd2e8","787":"0a04c06e"}[chunkId] + ".chunk.js";
};